document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-soie-quick-add]');
  if (!button || button.disabled) return;
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  try {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] })
    });
    if (!response.ok) throw new Error('Unable to add product');
    window.location.reload();
  } catch (error) {
    button.disabled = false;
    button.removeAttribute('aria-busy');
    button.querySelector('span:first-child').textContent = 'Try again';
  }
});
